import Molde from "./MoldeTransporte";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import CamionetaCard from "./CamionetaCard";
import React from 'react';


export default function TransporteCusco_ollanta() {
  return (
        <>
          <Molde
            image={"/images/cusco_ollanta_t.png"}
            title={"TRANSPORTE CUSCO - OLLANTAYTAMBO"}
            subtitle={"(Todo el día)"}
            description={
              "Este servicio de transporte privado ofrece un traslado cómodo y directo desde Cusco hasta Ollantaytambo, un importante punto de partida para los viajeros que desean visitar Machu Picchu o explorar el Valle Sagrado de los Incas. El servicio está diseñado para aquellos que prefieren un transporte privado y directo, sin visitas turísticas adicionales. El viaje de Cusco a Ollantaytambo tiene una duración aproximada de 1.5 a 2 horas, dependiendo del tráfico y las condiciones de la carretera. Durante el trayecto, los viajeros disfrutarán de hermosos paisajes andinos, montañas y pequeños pueblos a lo largo del camino."
            }
            
            //linkForm={"/reservar/citytour-dia"}
            //tipoprecio={"Precio por persona"}
            //monto={"US$ 11.00"}
            //moneda={"DOLARES"}
    
            picture1={            
              <>
              <div>
                <CardItinerario
                  num="01"
                  title="RECOJO"
                  lugar="CUSCO"
                  ></CardItinerario>
                  <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                    <div className="p-8">
                      <p className="text-justify text-primary-800"><strong>Punto de Recogida:</strong> El servicio de transporte comenzará con la recogida en el hotel o punto acordado en Cusco. El conductor estará puntual y buscará a los viajeros en el lugar indicado, con un cartel o en un vehículo identificado.</p>
                      <p className="text-justify text-primary-800" ><strong>Hora de Recogida:</strong> El horario de recogida puede ser personalizado según las necesidades de los viajeros. El servicio está disponible tanto por la mañana como por la tarde.</p>
                      <p className="text-justify text-primary-800"><strong>Vehículo:</strong> El servicio se realiza en vehículos cómodos y bien equipados, como minibuses, vans o coches privados, dependiendo de la cantidad de personas que viajan.</p>
                    </div>
                    <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                      <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/recojo_1.png`} alt="" />
                      <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/recojo_2.png`} alt="" />
                    </div>
                  </div>
                </div>
              </>
            }
    
            picture2={            
              <>
              <div>
                <CardItinerario
                  num="02"
                  title="TRAYECTO"
                  lugar="A OLLANTAYTAMBO"
                  ></CardItinerario>
                  <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                    <div className="p-8">
                      <p className="text-justify text-primary-800"><strong>Duración:</strong> Aproximadamente 1.5 a 2 horas de viaje, dependiendo del tráfico.</p>
                      <p className="text-justify text-primary-800" ><strong>Ruta:</strong> El viaje tomará la carretera principal desde Cusco hacia Urubamba, y luego continuará por el Valle Sagrado hasta llegar a Ollantaytambo.</p>
                      <p className="text-justify text-primary-800"><strong>Vistas panorámicas:</strong> Durante el trayecto, los viajeros disfrutarán de vistas panorámicas del Valle Sagrado, con montañas, campos agrícolas y ríos que hacen de este viaje una experiencia visualmente agradable.</p>
                    </div>
                    <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                      <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_2.png`} alt="" />
                      <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_4.png`} alt="" />
                    </div>
                  </div>
                </div>
              </>
            }
    
            picture3={            
              <>
              <div>
                <CardItinerario
                  num="03"
                  title="LLEGADA"
                  lugar="OLLANTAYTAMBO"
                  ></CardItinerario>
                  <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                    <div className="p-8">
                      <p className="text-justify text-primary-800">
                        <strong>Punto de Llegada:</strong> El servicio finalizará en Ollantaytambo, en el punto de recogida acordado. Los viajeros serán dejados en un lugar central de la ciudad, ya sea cerca de la estación de tren o en el centro del pueblo, según su preferencia.</p>
                      <p className="text-justify text-primary-800" >
                        <strong>Hora de Llegada:</strong> La llegada depende de la hora de recogida, pero se estima que será entre 1.5 y 2 horas después de la partida desde Cusco.</p>
                    </div>
                    <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                      <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/llegada_ollanta_1.png`} alt="" />
                      <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/llegada_ollanta_2.png`} alt="" />
                    </div>
                    
                  </div>
                </div>
              </>
            }
            
    
            incluye={
              <>
                <p className="text-primary-800 font-light">Transporte turistico</p>
                <p className="text-primary-800 font-light">Guia profesional</p>
                <p className="text-primary-800 font-light">Asistencia permanente</p>
              </>
            }
            noIncluye={
              <>
                <p className="text-primary-800 font-light">Ingreso a koricancha </p>
                <p className="text-primary-800 font-light">Boleto turistico </p>
                <p className="text-primary-800 font-light">Gastos extra</p>
              </>
            }
            caracteristica={
              <>
                <CardCaracteristica
                  icon={`${process.env.PUBLIC_URL}/icons/auto_t.svg`}
                  title={"Vehiculo"}
                  desc={"Auto moderno"}
                />
                <CardCaracteristica
                  icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                  title={"Tipo Servicio"}
                  desc={"VIP"}
                />
                <CardCaracteristica
                  icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                  title={"Duración"}
                  desc={"1.5 a 2 Horas"}
                />
                {/*
                <CardCaracteristica
                  icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                  title={"Tipo de Tour"}
                  desc={"Cultural"}
                />*/}
              </>
            }
            
            TourRecomienda={
              <>
                <CardRecomienda
                  img={"/images/montania_colores.png"}
                  title={"MONTAÑA 7 COLORES"}
                  puntuacion={"4.5"}
                  link={'/tour-tradicional/montania-colores'}
                />
                <CardRecomienda
                  img={"/images/valle-vip-5.png"}
                  title={"VALLE VIP"}
                  puntuacion={"5"}
                  link={'/tour-tradicional/valle-vip'}
                />
                <CardRecomienda
                  img={"/images/laguna_huamantay.png"}
                  title={"LAGUNA HUAMANTAY"}
                  puntuacion={"5"}
                  link={'/tour-tradicional/laguna-huamantay'}
                />
                <CardRecomienda
                  img={"/images/maras-moray-4.png"}
                  title={"MARAS-MORAY"}
                  puntuacion={"4.5"}
                  link={'/tour-tradicional/maras-moray'}
                />
              </>
            }
          />
        </>
      );
}
